/**
 * WorkforcePlanningV2.utils.js
 *
 * Pure helpers behind the Workforce Planning page — no React, no fetching —
 * so the CSV shaping can be read (and unit-tested) apart from the component
 * tree. Table filter options come from RedeploymentCenterV2.utils' getFilters
 * (both pages filter the same employee/JD row fields).
 */

/**
 * Flattens the demand roles into the Workforce Plan CSV rows — one row per
 * (role, candidate), or a single placeholder row for a role with no
 * candidates so the role still appears in the export. Candidates come from
 * useWorkforceDemandCandidates' per-role map (so API-backed roles are
 * covered too), each already carrying its `available` flag.
 */
export const buildWorkforcePlanCsvRows = (demandRoles, candidatesByRoleId) =>
  demandRoles.flatMap((role) => {
    const demand = `${role.currentPositionCount} → ${role.targetPositionCount}`;
    const candidates = candidatesByRoleId[role.id] ?? [];

    if (!candidates.length) {
      return [{ Role: role.title, Demand: demand, Person: "—", "SMI %": "—", Availability: "—" }];
    }

    return candidates.map((candidate) => ({
      Role: role.title,
      Demand: demand,
      Person: candidate.person?.name,
      // null (not yet scored) exports as "—", same as the on-screen dash —
      // otherwise the cell would literally read "null".
      "SMI %": candidate.sri == null ? "—" : candidate.sri,
      Availability: candidate.available ? "Available" : "Unavailable",
    }));
  });
